/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'bell': {
    width: 16,
    height: 18,
    viewBox: '0 0 16 18',
    data: '<g _stroke="currentColor" stroke-width="2" _fill="none"><path pid="0" d="M7.5 2h1A4.5 4.5 0 0113 6.5v3.43a2 2 0 00.89 1.664l1.665 1.11a1 1 0 01.445.831V15H0v-1.465a1 1 0 01.445-.832l1.664-1.11A2 2 0 003 9.93V6.5A4.5 4.5 0 017.5 2z" stroke-linejoin="round"/><path pid="1" d="M6 16a2 2 0 104 0M8 0v2"/></g>'
  }
})
